// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1lhc6","label":"SetPasswdForm_label__1p2un"};